import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'

Vue.config.productionTip = false

import Home from './Pages/Home'
import ExclusiveBrands from './Pages/ExclusiveBrands'
import OQueFazemos from './Pages/OQueFazemos'
import PrivateLavel from './Pages/PrivateLavel'
import QuemSomos from './Pages/QuemSomos'
import Produtos from './Pages/Produtos'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/exclusive-brands',
      name: 'exclusive-brands',
      component: ExclusiveBrands
    },
    {
      path: '/o-que-fazemos',
      name: 'o-que-fazemos',
      component: OQueFazemos
    },
    {
      path: '/private-label',
      name: 'private-label',
      component: PrivateLavel
    },
    {
      path: '/quem-somos',
      name: 'quem-somos',
      component: QuemSomos
    },
    {
      path: '/produtos',
      name: 'produtos',
      component: Produtos
    },
  ]
})

new Vue({
  render: h => h(Home),
  router
}).$mount('#app')
